// App 根组件（网页版）
// 根据登录状态切换 LoginPage / MainPage
import { useEffect, useState } from 'react';
import { ConfigProvider, theme, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import { getToken, clearToken } from './lib/api';

export default function App() {
  const [authed, setAuthed] = useState(!!getToken());

  useEffect(() => {
    // 监听 storage 事件（多 tab 登出）
    const handler = () => setAuthed(!!getToken());
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorBgBase: '#0d1117',
          colorPrimary: '#1677ff',
        },
      }}
    >
      {/* AntApp provider：必须包一层，否则所有子组件里 AntApp.useApp() 拿到的 message/modal/notification 都是空 stub，调用 .error()/.success() 不会真的显示出来 */}
      <AntApp>
        <div style={{ minHeight: '100vh', background: '#0d1117' }}>
          {authed ? (
            <MainPage onLogout={() => { clearToken(); setAuthed(false); }} />
          ) : (
            <LoginPage onLogin={() => setAuthed(true)} />
          )}
        </div>
      </AntApp>
    </ConfigProvider>
  );
}